import type {
  OperationLogExportParams,
  OperationModule,
  OperationResult,
  QueryOperationLogsParams,
} from './types'

function compactRecord<T extends Record<string, unknown>>(record: T) {
  return Object.fromEntries(
    Object.entries(record).filter(
      ([, value]) => value !== undefined && value !== '',
    ),
  ) as Partial<T>
}

export function toOperationModuleCode(value?: '' | OperationModule) {
  const moduleMap: Record<OperationModule, string> = {
    BM配置: 'BM_CONFIG',
    成员: 'MEMBER',
    资产: 'ASSET',
  }
  return value ? moduleMap[value] : undefined
}

export function toOperationActionCode(value?: string) {
  const actionMap: Record<string, string> = {
    停用: 'DISABLE',
    分配: 'ASSIGN',
    解除: 'UNASSIGN',
    启用: 'ENABLE',
    取消内部标记: 'CANCEL_INTERNAL_MARK',
    手动同步: 'MANUAL_SYNC',
    新增BM: 'CREATE_BM',
    更新权限: 'UPDATE_TASKS',
    标记内部人员: 'MARK_INTERNAL',
    编辑BM: 'UPDATE_BM',
    编辑内部标记: 'EDIT_INTERNAL_MARK',
  }
  return value ? (actionMap[value] ?? value) : undefined
}

export function toOperationResultValue(value?: '' | OperationResult) {
  if (!value) return undefined
  return value === 'ok'
}

export function buildOperationLogExportParams(
  params: QueryOperationLogsParams,
): OperationLogExportParams {
  const condition = params.condition ?? {}

  return {
    condition: compactRecord({
      action: toOperationActionCode(condition.action),
      dateRange: condition.dateRange,
      module: toOperationModuleCode(condition.module),
      operator: condition.op,
      result: toOperationResultValue(condition.result),
      target: condition.target,
    }),
    pageIndex: params.pageIndex,
    pageSize: params.pageSize,
  }
}
